import { render, staticRenderFns } from "./GymSpaceRouteList.vue?vue&type=template&id=0b64b1a7"
import script from "./GymSpaceRouteList.vue?vue&type=script&lang=js"
export * from "./GymSpaceRouteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports